import React from "react";

export const AI_SOURCES = [
  ["dashboard", "Dashboard"],
  ["evolutive", "Rapoarte evolutive (Serie temporala)"],
  ["cumulat", "Cumulat pe ore"],
  ["comparative", "Rapoarte comparative"],
];

const dayIso = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const defaultAISources = () => ({ sources: ["dashboard"], date_from: dayIso(29), date_to: dayIso(0) });
export const emptyAISources = () => ({ ...defaultAISources(), sources: [] });

const inp = "rounded border border-slate-300 bg-white px-2 py-1 text-xs";

export function AISourcePicker({ value, onChange, disabled, label = "Surse date" }) {
  const toggle = (k) => {
    const has = value.sources.includes(k);
    onChange({ ...value, sources: has ? value.sources.filter((s) => s !== k) : [...value.sources, k] });
  };
  const needsPeriod = value.sources.some((s) => s !== "dashboard");
  const setDate = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div data-testid="ai-source-picker" className="mb-3 flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-slate-200 pb-3 text-xs text-slate-700">
      <span className="uppercase tracking-widest text-slate-400">{label}</span>
      {AI_SOURCES.map(([k, l]) => (
        <label key={k} className="inline-flex cursor-pointer items-center gap-1.5">
          <input type="checkbox" data-testid={`ai-source-${k}`} checked={value.sources.includes(k)} onChange={() => toggle(k)} disabled={disabled} />
          {l}
        </label>
      ))}
      <span className={`ml-auto inline-flex items-center gap-2 ${needsPeriod ? "" : "opacity-40"}`}>
        De la
        <input type="date" data-testid="ai-source-date-from" className={inp} value={value.date_from} max={value.date_to} onChange={setDate("date_from")} disabled={disabled || !needsPeriod} />
        Pana la
        <input type="date" data-testid="ai-source-date-to" className={inp} value={value.date_to} min={value.date_from} max={dayIso(0)} onChange={setDate("date_to")} disabled={disabled || !needsPeriod} />
        <span className="text-slate-400">Tara: Toate</span>
      </span>
    </div>
  );
}
